import { Box } from "@mui/material";
import { useStorageUrlWithCredentials } from "../../components/imagesPreview/storageUrlWithCredentials";
import { PACKAGE_ASPECT_RATIO } from "../packageMedia";
interface PackageMapProps {
  handleOpenLightbox: (imageUrl: string) => void;
  mapImageUrl?: string;
}

function PackageMap({ handleOpenLightbox, mapImageUrl }: PackageMapProps) {
  const mapThumbnailUrl = useStorageUrlWithCredentials(mapImageUrl);
  if (!mapImageUrl || !mapThumbnailUrl) {
    return null;
  }
  return (
    <Box
      sx={{
        borderRadius: 1,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.08)",
        cursor: "pointer",
        bgcolor: "#fff",
        position: "relative",
        aspectRatio: { xs: PACKAGE_ASPECT_RATIO, md: "auto" },
        height: { xs: "auto", md: "100%" },
        minHeight: { md: 0 },
      }}
      onClick={() => handleOpenLightbox(mapThumbnailUrl)}
    >
      <Box
        component="img"
        src={mapThumbnailUrl}
        alt="Mapa trasy wycieczki"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
          position: "absolute",
          inset: 0,
        }}
      />
    </Box>
  );
}

export default PackageMap;
